class ReportEntry
    constructor: (el) ->
        @.$el = el
        @.$errorEl = @.$el.querySelector '.report-entry__error'
        @.$postEl = @.$el.querySelector '.report-entry__post'
        @.$reasonEl = @.$el.querySelector '.report-entry__reason-text'
        @.$reasonInputEl = @.$reasonEl.querySelector 'textarea'
        @.$submitButton = @.$el.querySelector '.report-entry__submit'
        @.$successEl = @.$el.querySelector '.report-entry__success'
        @.$userEl = @.$el.querySelector '.report-entry__user'
        @.$userNameEl = @.$el.querySelector '.report-entry__user-name'
        @.$userPicEl = @.$el.querySelector '.report-entry__user-pic'

        @.api = @.$el.dataset?.api ? false
        @.apiMethod = @.$el.dataset?.apiMethod ? 'GET'
        @.errorActive = @.$el.classList.contains 'report-entry--error'
        @.postId = false
        @.postActive = @.$el.classList.contains 'report-entry--post'
        @.successActive = @.$el.classList.contains 'report-entry--success'
        @.successRedirect = @.$el.dataset?.successRedirect ? false
        @.userId = false
        @.valid = true

        @.$el.classList.add 'report-entry--bound'
        @.InitEvents()
        return
    
    InitEvents: ->
        self = @
        @.$el.addEventListener 'report-entry-set', (e) ->
            post = e.detail?.post ? ""
            postId = e.detail?.postId ? false
            user = e.detail?.user ? {}
            self.SetPost post, postId
            self.SetUser user
            return
        @.$submitButton.addEventListener 'click', (e) ->
            e.preventDefault()
            self.Validate()
            if !self.errorActive && !self.successActive && self.valid
                self.SendData()
            return
        return

    RedirectAction: ->
        if @.successRedirect
            if @.$parentOverlay
                if @.$parentOverlay.dataset?.id
                    overlayEl = document.getElementById @.$parentOverlay.dataset.id
                    if overlayEl
                        redirectOnClose = "#{@.successRedirect}"
                        overlayEl.dispatchEvent new CustomEvent 'overlay-set-redirect-on-close', {
                            bubbles: false,
                            detail: {
                                redirectOnClose: redirectOnClose
                            }
                        }
            else
                if @.successRedirect == "reload"
                    window.location.reload()
                else
                    window.location @.successRedirect
        return
    
    SendData: ->
        if (@.apiMethod == 'GET' || @.apiMethod == 'POST') && @.api && @.postId && @.userId && @.valid
            self = @
            try
                if @.apiMethod == 'POST'
                        body = {
                            comment: @.$reasonInputEl.value
                            post: @.postId
                            user: @.userId
                        }
                request = window.appUtils.XMLHttpRequest @.apiMethod, @.api
                    , ->
                        if request.responseText && request.responseText != ""
                            try
                                response = JSON.parse request.responseText
                                if response.success
                                    self.SetSuccessMessage response.message
                                    self.RedirectAction()
                                if response.error
                                    self.SetErrorMessage response.message
                            catch error
                                console.log "Beim Versuch Daten zu senden trat ein Fehler auf", error
                                return
                        else
                            console.log "Die Antwort der Schnittstelle auf die gesendeten Daten war leer oder blieb aus."
                    , ->
                        console.log "Bei der Anfrage an die Schnittstelle ist leider ein Fehler aufgetreten"
                        return
                    , if self.apiMethod == 'POST' then JSON.stringify(body) else {}
            catch error
                console.log "Beim Versuch Daten zu senden trat ein Fehler auf", error
        return
    
    SetUser: (user) ->
        userId = user?.id ? false
        userName = user?.name ? "Unbekannter Nutzer"
        userPic = user?.pic ? false
        if userId
            @.userId = userId
            @.$userEl.dataset.userId = userId
            if userName && userName != ""
                @.$userNameEl.textContent = userName
            if userPic
                profilePicEl = @.$userPicEl.querySelector '.report-entry__profile-pic'
                if profilePicEl
                    profilePicEl.remove()
                profilePicEl = window.CreateProfilePic {
                    onWhite: true
                    pic: userPic
                    small: true
                }
                @.$userPicEl.append profilePicEl
        return

    SetErrorMessage: (errorMessage) ->
        if errorMessage && errorMessage != ""
            @.successActive = false
            @.$el.classList.remove 'report-entry--success'
            @.$errorEl.innerHTML = errorMessage
            @.errorActive = true
            @.$el.classList.add 'report-entry--error'
        else
            @.errorActive = false
            @.$el.classList.remove 'report-entry--error'
            @.$errorEl.innerHTML = ""
        return
    
    SetPost: (post, postId) ->
        if post && post != "" && postId
            @.$postEl.innerHTML = post
            @.$el.classList.add 'report-entry--post'
            @.postId = postId
        else
            @.$postEl.innerHTML = ""
            @.$el.classList.remove 'report-entry--post'
            @.postId = false
        @.postActive = @.$el.classList.contains 'report-entry--post'
        return
    
    SetSuccessMessage: (successMessage) ->
        if successMessage
            @.errorActive = false
            @.$el.classList.remove 'report-entry--error'
            @.$successEl.innerHTML = successMessage
            @.successActive = true
            @.$el.classList.add 'report-entry--success'
        else
            @.successActive = false
            @.$el.classList.remove 'report-entry--success'
            @.$successEl.innerHTML = ""
        return
    
    Validate: ->
        self = @
        @.valid = true
        errorMessage = "Es wurden nicht alle Pflichtfelder ausgefüllt:<br/>"
        if @.$reasonInputEl.value == ""
            @.valid = false
            errorMessage += "
                <br/>
                Es muss ein Grund für die Meldung angegeben werden
            "
            @.$reasonEl.dispatchEvent new CustomEvent 'textarea-set-error', {
                bubbles: false
                detail: {
                    error: @.$reasonInputEl.value == ""
                }
            }
        if !@.valid
            @.SetErrorMessage errorMessage
        else
            @.SetErrorMessage false
        return

BindReportEntries = ->
    document.querySelectorAll '.report-entry:not(.report-entry--bound)'
        .forEach (el) ->
            new ReportEntry el
            return
    return

window.addEventListener 'bind-components', BindReportEntries